<template>
  <div class="detail-sign-info">
    <div class="heard">
      <el-form :inline="true" :model="signInfo">
        <div class="sign-form clearfix">
          <div class="top-box">
            <div class="form-item item_bto">
              <el-form-item label="用户名:">
                <el-input
                  placeholder="请输入用户名"
                  v-model="userName"
                  class="namee"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号:">
                <el-input
                  placeholder="请输入手机号"
                  v-model="phone"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号:">
                <el-input
                  placeholder="请输入身份证号"
                  v-model="idcart"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item item_btn" style="margin-left: 10px">
              <el-form-item
                ><el-button type="primary" @click="initList(1)">
                  查询
                </el-button>
                <el-button type="warning" @click="chongzhi"> 重置 </el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>

      <el-row
        :style="{ marginTop: '5px', marginBottom: '10px' }"
        align="middle"
        type="flex"
        class="row-bg"
      >
        <el-button
          type="info"
          size="small"
          @click="goBack"
          icon="el-icon-arrow-left"
          >返回</el-button
        >
        <el-button type="info" @click="getcommand"> 导出到excel </el-button>
      </el-row>
    </div>
    <el-table
      :data="personList"
      border
      style="width: 100%"
      stripe
      id="tableform"
    >
      <el-table-column type="selection" width="40"> </el-table-column>
      <el-table-column
        type="index"
        align="center"
        width="60"
        :index="(signInfo.commonDto.page - 1) * signInfo.commonDto.limit + 1"
        label="#"
      >
      </el-table-column>
      <div class="" v-for="(item, index) in mubanlist.input" :key="index">
        <el-table-column
          :label="item.name"
          align="center"
          width="100"
          show-overflow-tooltip
          :prop="item.attribute"
        >
        </el-table-column>
      </div>
      <div class="" v-for="(item, index) in mubanlist.upload" :key="index">
        <el-table-column
          :label="item.name"
          align="center"
          show-overflow-tooltip
          :prop="item.attribute"
        >
        </el-table-column>
      </div>
      <el-table-column
        label="账号id"
        align="center"
        show-overflow-tooltip
        prop="id"
      >
      </el-table-column>
      <el-table-column
        label="用户名"
        align="center"
        width="80"
        show-overflow-tooltip
        prop="userName"
      >
      </el-table-column>
      <el-table-column
        label="手机号"
        align="center"
        width="120"
        show-overflow-tooltip
        prop="phone"
      >
      </el-table-column>
      <!-- <el-table-column
        label="点赞数"
        align="center"
        width="80"
        show-overflow-tooltip
        prop="like"
      >
      </el-table-column> -->
      <!-- <el-table-column
        label="评论数"
        align="center"
        width="80"
        show-overflow-tooltip
        prop="comment"
      >
      </el-table-column> -->
      <el-table-column
        label="销售订单数"
        align="center"
        show-overflow-tooltip
        prop="salesOrder"
      >
      </el-table-column>
      <el-table-column
        label="新增粉丝数"
        align="center"
        show-overflow-tooltip
        prop="increaseFans"
      >
      </el-table-column>
      <!-- <el-table-column
        label="最高同时在线人数"
        align="center"
        width="100"
        show-overflow-tooltip
        prop="highestOnline"
      >
      </el-table-column> -->
      <el-table-column
        label="累计观看人数"
        align="center"
        show-overflow-tooltip
        prop="watchPeople"
      >
      </el-table-column>
      <el-table-column
        prop="idCard"
        label="身份证号"
        align="center"
        width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
      prop="forward"
      label="转发数"
      align="center"
      width="80"
      show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column
        label="宣传视频"
        prop="pictureThreeUrl"
        align="center"
        width="120"
      >
      <template slot-scope="scope">
        <div class="img-show" style="cursor: pointer;">
            <el-image
                v-if="scope.row.pictureThreeUrl != null"
                width="75%"
                contain
                class="image-slot"
                :src="scope.row.pictureThreeUrl"
                fit="contain"
                @click="videoPlay(scope.row.videoUrl)"
            ></el-image>
            <div v-else slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
        </div>
      </template>
      </el-table-column> -->
      <el-table-column
        prop="pictureOneUrl"
        label="直播后台数据"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div class="img-show">
            <el-image
              v-if="scope.row.pictureOneUrl != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.pictureOneUrl"
              :preview-src-list="[scope.row.pictureOneUrl]"
              fit="cover"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
      prop="pictureTwoUrl"
      label="附件二"
      align="center"
      width="120"
      show-overflow-tooltip
      >
       <template slot-scope="scope">
        <div class="img-show">
          <el-image
              v-if="scope.row.pictureTwoUrl != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.pictureTwoUrl"
              :preview-src-list="[scope.row.pictureTwoUrl]"
              fit="cover"
          ></el-image>
          <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
          </div>
        </div>
      </template>
      </el-table-column>
      <el-table-column
      prop="pictureThreeUrl"
      label="附件三"
      align="center"
      width="120"
      show-overflow-tooltip
      >
      <template slot-scope="scope">
        <div class="img-show">
          <el-image
              v-if="scope.row.pictureThreeUrl != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.pictureThreeUrl"
              :preview-src-list="[scope.row.pictureThreeUrl]"
              fit="cover"
          ></el-image>
          <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
          </div>
        </div>
      </template>
      </el-table-column> -->
      <el-table-column
        prop="gmv"
        label="GMV 成交额"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>

    <!-- 报名列表分页器 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="personTotal"
      @current-change="pageChange"
      :page-size="signInfo.commonDto.limit"
      :current-page="signInfo.commonDto.page"
    >
    </el-pagination>

    <!-- 视频播放弹出框 -->
    <el-dialog
      title="视频播放"
      :visible.sync="dialogVideoVisible"
      @close="parseVideo"
    >
      <video
        :src="videoUrl"
        controls
        :style="{ width: '100%', 'max-height': '400px' }"
        id="video-play"
      ></video>
    </el-dialog>

    <!-- 视频播放弹出框 -->
    <!-- <el-dialog
      title="视频播放"
      :visible.sync="dialogVideoVisible"
      @close="parseVideo"
    >
      <video
        :src="videoUrl"
        controls
        :style="{ width: '100%', 'max-height': '400px' }"
        id="video-play"
      ></video>
    </el-dialog> -->
    <!-- 审核新添加列表的弹框 -->
    <!-- <check-status
            :check-query="checkQuery"
            ref="checkRef"
            @updateComputed="getPersonList()"
        /> -->
  </div>
</template>

<script>
import { showcontent } from "@/utils/method.js";
// import AddOrUpdate from "@/views/modules/config/child-components/activities-add-or-tongji";
// import table2excel from "js-table2excel";
import axios from "axios";
export default {
  data() {
    return {
      dialogVideoVisible: false,
      videoUrl: "",
      userName: "",
      idcart: "",
      phone: "",
      activitiesids: "",
      addOrUpdateVisible: false,
      //对话框是否展示
      dialogTableVisible: false,
      // 获取报名信息列表参数
      personQuery: {
        acid: null,
      },
      // 报名信息列表
      personList: [],
      mubanlist: [],
      // 报名总人数
      personTotal: 0,
      // 活动名称
      activitiesName: "",
      //  要删除的数据数组/批量审核的数组
      deleteIds: [],
      //报名列表查询条件
      signInfo: {
        activitiesId: null,
        userName: "",
        // phone: "",
        idCard: "",
        type: "",
        commonDto: {
          limit: 10,
          page: 1,
        },
        userType: "",
        verifyStatus: "",
        startTime: "",
        endTime: "",
        cityCode: "",
      },
      // const excelName = "boy";
      // table2excel(column, data, excelName);
      // 用户职业信息列表
      // occupInfo: [
      //   { name: "在校学生", id: "1" },
      //   { name: "社会人士", id: "2" },
      // ],
      // 审核状态信息
      // stateInfo: [
      //   { name: "待审核", id: "0" },
      //   { name: "审核通过", id: "1" },
      //   { name: "审核不通过", id: "2" },
      // ],
      // 批量审核的参数
      // mutiAuditQuery: {
      //   context: "",
      //   status: "",
      // },
      // 控制审核不通过描述框的显示与隐藏
      // examDialogVisible: false,
      // 城市信息列表
      // cityCodeList: [],
      // 日期时间选择框的值
      // valueDate: [],
      // 加载组件的显示隐藏
      // loading: false,
    };
  },
  created() {
    this.initList();
    this.init();
    // this.getCityCode();
  },
  // computed: {
  //   //   对字符串进行转义
  //   escopeObj() {
  //     return (str) => {
  //       return JSON.parse(showcontent(showcontent(str)));
  //     };
  //   },
  //   // 计算所属城市
  //   cityName() {
  //     return (code) => {
  //       return this.cityCodeList.find((item) => item.code === code);
  //     };
  //   },
  // },
  methods: {
    chongzhi() {
      this.userName = '',
       this.idcart = '',
        this.phone = ""
        this.$nextTick(() =>{
          this.initList()
        })
    },
    // // 新增或修改活动赛事
    // addOrUpdateHandle(id) {
    //   this.addOrUpdateVisible = true;
    //   this.$nextTick(() => {
    //     this.$refs.addOrUpdateRef.init(id);
    //   });
    // },
    // showcontent,
    // init() {
    //   this.personQuery.acid = this.$route.params.id;
    //   this.signInfo.activitiesId = parseInt(this.$route.params.id);
    //   this.getPersonList();
    //   this.getactivelist(this.signInfo.activitiesId);
    // },
    // getactivelist(id) {
    //   this.$ajaxGet("/activities/info/open/" + id).then(({ data }) => {
    //     console.log(data);
    //     this.templateId = data.data.templateId;
    //     this.getmubanlist(this.templateId);
    //     this.activitiesids = data.data.id;
    //   });
    // },
    // getmubanlist(id) {
    //   if (id) {
    //     this.$ajaxGet("/registrationTemplate/getById/open?id=" + id).then(
    //       ({ data }) => {
    //         console.log(data);
    //         this.mubanlist = JSON.parse(showcontent(data.data.content));
    //       }
    //     );
    //   }
    // },
    // 播放视频
    videoPlay(url) {
      this.videoUrl = url;
      this.dialogVideoVisible = true;
    },
    parseVideo() {
      // 关闭对话框暂停视频
      const id = document.querySelector("#video-play");
      id.pause();
    },
    // 成绩导出
    getcommand() {
      axios({
        method: "post",
        url: `/sys/activitiesSignupData/open/excel?activityId=${this.personQuery.acid.toString()}`,
        responseType: "arraybuffer",
      }).then((res) => {
        console.log(res);
        const data = res.data;
        const url = window.URL.createObjectURL(
          new Blob([data], { type: "application/vnd.ms-excel" })
        );
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.download = "成绩列表";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    init() {
      this.personQuery.acid = this.$route.params.id;
    },
    // 获取信息详情
    initList(a) {
      if (a == 1) {
        this.signInfo.commonDto.page = 1;
      }
      this.$ajaxGet("sys/activitiesSignupData/getInfoByActivityId/open", {
        page: this.signInfo.commonDto.page,
        limit: this.signInfo.commonDto.limit,
        activityId: this.$route.params.id,
        phone: this.phone,
        username: this.userName,
        idCard: this.idcart,
      }).then(({ data }) => {
        console.log(data);
        this.personList = [];
        for (let index = 0; index < data.data.records.length; index++) {
          const element = data.data.records[index];
          if (element.broadcastScore != null && element.otherInfo != null) {
            const broadcastScore = JSON.parse(
              showcontent(element.broadcastScore)
            );
            // const publicityScore = JSON.parse(showcontent(element.publicityScore))
            const otherInfo = JSON.parse(showcontent(element.otherInfo));
            const list = {};
            list.highestOnline = broadcastScore.highestOnline;
            list.increaseFans = element.increaseFans;
            list.salesOrder = element.salesOrder;
            list.watchPeople = element.watchPeople;
            list.phone = element.phone;
            list.userName = element.userName;
            list.idCard = element.idCard;
            list.id = otherInfo.Liveaccount;
            list.gmv = broadcastScore.gmv;
            list.heighestOnline = broadcastScore.heighestOnline;
            list.pictureOneUrl = broadcastScore.pictureOneUrl;
            list.pictureThreeUrl = broadcastScore.pictureThreeUrl;
            list.pictureTwoUrl = broadcastScore.pictureTwoUrl;
            list.totalAddFan = broadcastScore.totalAddFan;
            list.totalWatch = broadcastScore.totalWatch;
            // list.comment = publicityScore.comment
            // list.forward = publicityScore.forward
            // list.like = publicityScore.like
            // list.videoUrl = publicityScore.videoUrl
            this.personList.push(list);
            console.log(this.personList);
          }
        }
        this.personTotal = Number(data.data.total);
      });
    },

    // 分页器页数改变时触发
    pageChange(val) {
      this.signInfo.commonDto.page = val;
      // this.getPersonList();
      this.initList();
    },
    // 返回上一个页面
    goBack() {
      this.$router.back();
    },
    // // 日期变化
    // dateChange(val) {
    //   if (val) {
    //     this.signInfo.startTime = val[0];
    //     this.signInfo.endTime = val[1];
    //   } else {
    //     this.signInfo.startTime = "";
    //     this.signInfo.endTime = "";
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-icon-circle-close {
  color: white;
}
.detail-sign-info {
  background: #fff;
  padding: 15px 20px;
}
.namee {
  width: 130px;
}
@primaryColor: #409eff;
.img-show {
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.seach {
  width: 130%;
}
/deep/.el-row--flex {
  display: block;
}
.heard {
  display: flex;
  justify-content: space-between;
}
/deep/.el-table {
  font-size: 14px;
}
.check-btns {
  display: flex;
  justify-content: space-around;
  align-items: center;
  span {
    color: @primaryColor;
    font-size: 12px;
    cursor: pointer;
    &:first-child:hover {
      color: #67c23a;
    }
    &:last-child:hover {
      color: #f56c6c;
    }
  }
}
.delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 12px;
    color: @primaryColor;
    cursor: pointer;
  }
}
.img-content {
  width: 40px;
  height: 40px;
}
/deep/ .el-table__body-wrapper {
  overflow-y: auto;
}
.row-bg {
  .el-col-22 {
    .el-form {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
/deep/ .user-name .el-input__inner {
  width: 100px;
}
/deep/ .paltform-name .el-input__inner {
  width: 120px;
}
/deep/ .option-width {
  // margin-left: 10px;
  .el-input {
    .el-input__inner {
      width: 120px;
    }
  }
}
.primary {
  color: #007acc;
}
.sign-form {
  .top-box,
  .bottom-box {
    display: flex;
    .item_bto {
      margin-left: 5px;
    }
  }
}
</style>